import * as React from 'react'
import {
  Box,
  Tabs,
  Tab,
  Paper,
  Grid,
  Container,
  useMediaQuery,
  useTheme,
  Button,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Modal,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Switch,
  FormControlLabel,
  Checkbox,
} from '@mui/material'
import Dialog from '@mui/material/Dialog'
import AppBar from '@mui/material/AppBar'
import Toolbar from '@mui/material/Toolbar'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import CloseIcon from '@mui/icons-material/Close'
import Slide from '@mui/material/Slide'
import ManageCategories from './ManageCategories'
import { useEffect } from 'react'
import { useState } from 'react'
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth'
import AccountBalanceIcon from '@mui/icons-material/AccountBalance'

import {
  LightbulbOutlined as LightbulbOutlinedIcon,
  PersonAddOutlined as PersonAddOutlinedIcon,
  EditOutlined as EditOutlinedIcon,
  SaveOutlined as SaveOutlinedIcon,
  EventOutlined as EventOutlinedIcon,
  DeleteOutline as DeleteOutlineIcon,
  NoteAddOutlined as NoteAddOutlinedIcon,
  AddBoxOutlined as AddBoxOutlinedIcon,
} from '@mui/icons-material'
import AttachmentIcon from '@mui/icons-material/Attachment'

import { useSelector } from 'react-redux'
import { Link, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { makeGetRequest } from 'utils/api'
import { makePostRequest } from 'utils/api'
import { makeDeleteRequest } from 'utils/api'
import urls from 'utils/urls'
import CreateDocumentsForm from './CreateDocumentsForm'
import CustomButton from './CustomButton/CustomButton'
import { convertToUserDateFormate } from 'utils/helpers'
import { convertToMuiDate } from 'utils/helpers'
import CreateEvent from 'containers/MesToDo/CreateEvent'
import { makePutRequest } from 'utils/api'
import CreateTache from 'containers/MesToDo/CreateTache'
import CreateNote from 'containers/MesToDo/CreateNote'
import { toast } from 'react-toastify'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

// --- Data Structure ---
const billHeader = {
  amount: '342.80',
  currency: '€',
  title: 'Electricity Bill',
  category: 'Utilities',
  date: '23 March 2025',
}

const tabLabels = ['Général', 'Contact', 'Budget', 'Événement', 'Document', 'Tâche / Note']

// Types de faits fiscaux proposés pour le flag manuel opération → impôts
// (même liste que la section Opérations du Tax Center ; libellés i18n
// partagés `taxCenter.factTypes.*`).
const TAX_FACT_TYPES = [
  'EMPLOYMENT_INCOME',
  'RETIREMENT_CONTRIBUTION',
  'PENSION_BUYBACK',
  'CHARITABLE_DONATION',
  'CHILDCARE_EXPENSE',
  'ALIMONY_PAID',
  'PROFESSIONAL_EXPENSE',
  'PROFESSIONAL_TRAINING',
  'COMMUTE_EXPENSE',
  'HEALTH_EXPENSE',
  'INSURANCE_PREMIUM',
  'PROPERTY_MAINTENANCE_EXPENSE',
  'MORTGAGE_INTEREST',
  'WITHHOLDING_TAX',
  'TAX_INSTALLMENT_PAID',
]

// Bloc « Déduction fiscale » de l'onglet Général : relie l'opération à un
// fait fiscal (TaxOperationTag, POST idempotent) ou l'exclut de la
// détection automatique. Le backend marque la position fiscale dirty →
// recalcul lazy à la prochaine visite du Tax Center.
const TaxDeductionSection = ({ row }) => {
  const { t } = useTranslation('layout')
  const [tag, setTag] = useState(null)
  const [loaded, setLoaded] = useState(false)
  const [busy, setBusy] = useState(false)

  useEffect(() => {
    const load = async () => {
      const res = await makeGetRequest(
        `${urls.taxOperationTags}?operation=${row.id}`,
        {},
        true,
      )
      if (res?.status === 200) {
        const results = res.data?.results || []
        setTag(results[0] || null)
      }
      setLoaded(true)
    }
    load()
  }, [row.id])

  const onChange = async (value) => {
    setBusy(true)
    if (!value) {
      // Retour au mode auto : suppression du tag manuel.
      if (tag?.id) {
        const res = await makeDeleteRequest(urls.taxOperationTag(tag.id), {}, true)
        if (res?.status === 204 || res?.status === 200) {
          setTag(null)
          toast.success(t('taxCenter.opsSaved'))
        }
      }
    } else {
      const res = await makePostRequest(
        urls.taxOperationTags,
        { operation: row.id, fact_type: value },
        {},
        true,
      )
      if (res?.status === 201 || res?.status === 200) {
        setTag(res.data)
        toast.success(t('taxCenter.opsSaved'))
      }
    }
    setBusy(false)
  }

  return (
    <Box
      sx={{
        padding: { xs: 2, sm: 3 },
        backgroundColor: '#1f2937',
        borderRadius: '8px',
        boxShadow: '0 10px 15px rgba(0, 0, 0, 0.2)',
        marginTop: 3,
      }}
    >
      <Typography
        variant="h6"
        sx={{
          color: 'white',
          marginBottom: 1,
          borderBottom: '1px solid #374151',
          paddingBottom: 1,
          fontSize: '1.2rem',
        }}
      >
        {t('taxCenter.opsDeductionTitle')}
      </Typography>
      <Typography sx={{ color: '#9ca3af', fontSize: '0.85rem', marginBottom: 2 }}>
        {t('taxCenter.opsHint')}
      </Typography>
      <FormControl size="small" sx={{ minWidth: 260 }}>
        <Select
          value={tag ? tag.fact_type : ''}
          onChange={(e) => onChange(e.target.value)}
          displayEmpty
          disabled={!loaded || busy}
          sx={{
            color: 'white',
            '.MuiOutlinedInput-notchedOutline': { borderColor: '#374151' },
            '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#3b82f6' },
            '.MuiSvgIcon-root': { color: '#9ca3af' },
          }}
          MenuProps={{ PaperProps: { sx: { bgcolor: '#1f2937', color: 'white' } } }}
        >
          <MenuItem value="">{t('taxCenter.opsAuto')}</MenuItem>
          {TAX_FACT_TYPES.map((ft) => (
            <MenuItem key={ft} value={ft}>
              {t(`taxCenter.factTypes.${ft}`, ft)}
            </MenuItem>
          ))}
          <MenuItem value="EXCLUDED">{t('taxCenter.opsExcluded')}</MenuItem>
        </Select>
      </FormControl>
    </Box>
  )
}

const DetailItem = ({ label, value }) => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'space-between',
      paddingY: 2,
      borderBottom: '1px solid rgba(55, 65, 81, 0.7)',
      '&:last-child': {
        borderBottom: 'none',
      },
    }}
  >
    <Typography
      variant="body1"
      sx={{
        color: '#9ca3af',
        fontWeight: 300,
        fontSize: { xs: '0.875rem', sm: '1rem' },
      }}
    >
      {label}
    </Typography>
    <Typography
      variant="body1"
      sx={{
        color: 'white',
        fontWeight: 500,
        fontSize: { xs: '0.875rem', sm: '1rem' },
      }}
    >
      {value}
    </Typography>
  </Box>
)

export default function OperationFiDetail({ handleClose, row }) {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const siteUser = useSelector((store) => store.user)

  const handleChange = (newTabId) => {
    setActiveTab(newTabId)
  }
  const [activeTab, setActiveTab] = useState(0)
  const [budgetVal, setBudgetVal] = useState(row?.row?.Montant)
  const [detailData, setDetailData] = useState([])

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue)
  }
  useEffect(() => {
    setDetailData([
      { label: 'Montant', value: `${row.row.Montant} €` },
      { label: 'Type', value: row.row.type_operation === 'D' ? 'Dépense' : 'Revenu' },
      {
        label: 'Catgorie',
        value: row.row.SousCategorie.length > 0 ? row.row.SousCategorie[0].Categorie : '',
      },
      {
        label: 'Sous-Catégorie',
        value: row.row.SousCategorie.length > 0 ? row.row.SousCategorie[0].SousCategorie : '',
      },
      { label: 'Comptes', value: row.row?.NCompte?.ncNom || '' },
      { label: 'Date', value: convertToUserDateFormate(siteUser.user, row.row.Date) },
      {
        label: 'Dernière modification',
        value: convertToUserDateFormate(siteUser.user, row.row.Date),
      },
    ])
  }, [])
  return (
    <div>
      <Dialog
        fullScreen
        open={true}
        TransitionComponent={Transition}
        sx={{ '.MuiDialog-paper': { backgroundColor: theme.palette.appBar.main } }}
      >
        <AppBar
          sx={{
            position: 'relative',
            backgroundColor: theme.palette.appBar.top,
          }}
        >
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={() => handleClose({})}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              Détails d’opération
            </Typography>
          </Toolbar>
        </AppBar>
        <Box
          style={{
            backgroundColor: theme.palette.appBar.main,
          }}
        >
          <Container>
            <Box
              sx={{
                minHeight: '100vh',

                padding: { xs: 2, sm: 4 },
                fontFamily: 'Inter, sans-serif',
              }}
            >
              <Box sx={{ maxWidth: '800px', margin: '0 auto' }}>
                <Paper
                  sx={{
                    padding: 3,
                    color: 'white',
                    borderRadius: '12px',
                    boxShadow: '0 10px 15px rgba(0, 0, 0, 0.3)',
                    marginBottom: 4,
                    overflow: 'hidden',
                    backgroundColor: '#1f2937',
                    position: 'relative',
                  }}
                >
                  <Box
                    sx={{
                      position: 'absolute',
                      top: 0,
                      right: 0,
                      width: '100%',
                      height: '100%',
                      opacity: 0.3,
                      pointerEvents: 'none',
                      borderRadius: '12px',
                    }}
                    style={{
                      background: 'linear-gradient(135deg, #4c6d59 0%, #826e47 50%, #af7551 100%)',

                      clipPath: 'polygon(40% 0%, 100% 0%, 100% 100%, 0% 100%)',
                    }}
                  />

                  <Box sx={{ position: 'relative', zIndex: 10 }}>
                    <Typography
                      variant="h4"
                      component="div"
                      sx={{
                        fontSize: { xs: '2.5rem', sm: '3rem' },
                        fontWeight: 300,
                        marginBottom: 1,
                        color: row?.row?.Montant > 0 ? '#2fff9e' : 'red',
                      }}
                    >
                      <Box component="span" sx={{ fontWeight: 400 }}>
                        €
                      </Box>{' '}
                      {budgetVal}
                    </Typography>

                    <Typography
                      variant="h2"
                      component="h1"
                      sx={{
                        fontSize: { xs: '2.5rem', sm: '3rem' },
                        fontWeight: 700,
                        marginBottom: 4,
                        lineHeight: 1.2,
                        textAlign: 'left',
                        color: 'white',
                      }}
                    >
                      {row?.row?.Libelle}
                    </Typography>

                    <Grid container sx={{ marginTop: 4, alignItems: 'center' }}>
                      <Grid
                        item
                        xs={7}
                        sm={6}
                        sx={{ display: 'flex', alignItems: 'center', columnGap: 1 }}
                      >
                        <LightbulbOutlinedIcon sx={{ color: '#c084fc', fontSize: '1.25rem' }} />
                        <Typography
                          variant="body1"
                          sx={{ color: '#d1d5db', fontWeight: 300, fontSize: '0.875rem' }}
                        >
                          {row.row.SousCategorie.length > 0
                            ? row.row.SousCategorie[0].Categorie
                            : ''}
                        </Typography>
                      </Grid>
                      <Grid item xs={5} sm={6} sx={{ textAlign: 'right' }}>
                        <Typography variant="body2" sx={{ color: '#d1d5db', fontSize: '0.875rem' }}>
                          {convertToUserDateFormate(siteUser.user, row?.row?.Date)}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Box>
                </Paper>

                <Box sx={{ marginBottom: 3, borderBottom: '1px solid #374151' }}>
                  <Tabs
                    value={activeTab}
                    onChange={handleTabChange}
                    aria-label="detail tabs"
                    TabIndicatorProps={{
                      style: { backgroundColor: '#3b82f6', height: '3px' },
                    }}
                    sx={{
                      '.MuiTab-root': {
                        color: '#9ca3af',
                        fontWeight: '500',
                        textTransform: 'none',
                        padding: '12px 16px',
                        minWidth: 'auto',
                        fontSize: '0.9rem',
                        '&:hover': {
                          color: '#ffffff',
                        },
                      },
                      '.Mui-selected': {
                        color: '#3b82f6 !important',
                        fontWeight: '700',
                      },
                    }}
                    variant="scrollable"
                    scrollButtons="auto"
                  >
                    {tabLabels.map((label, index) => (
                      <Tab key={index} label={label} />
                    ))}
                  </Tabs>
                </Box>

                {activeTab === 0 && (
                  <Box
                    sx={{
                      padding: { xs: 2, sm: 3 },
                      backgroundColor: '#1f2937',
                      borderRadius: '8px',
                      boxShadow: '0 10px 15px rgba(0, 0, 0, 0.2)',
                    }}
                  >
                    <Typography
                      variant="h6"
                      sx={{
                        color: 'white',
                        marginBottom: 2,
                        borderBottom: '1px solid #374151',
                        paddingBottom: 1,
                        fontSize: '1.2rem',
                      }}
                    >
                      Détails Généraux
                    </Typography>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                      {detailData.map((item, index) => (
                        <DetailItem key={index} label={item.label} value={item.value} />
                      ))}
                    </Box>
                    <TaxDeductionSection row={row.row} />
                  </Box>
                )}
                {activeTab === 1 && <ContactTabContent row={row.row} />}

                {activeTab === 2 && <BudgetTabContent row={row.row} setBudgetVal={setBudgetVal} />}
                {activeTab === 3 && <EventTabContent row={row.row} />}
                {activeTab === 4 && (
                  <Box
                    sx={{
                      padding: { xs: 2, sm: 3 },
                      backgroundColor: '#1f2937',
                      borderRadius: '8px',
                      boxShadow: '0 10px 15px rgba(0, 0, 0, 0.2)',
                      color: 'white',
                    }}
                  >
                    <BasicTable1 op_row={row.row} />
                  </Box>
                )}

                {activeTab === 5 && <TaskNoteTabContent row={row.row} />}
              </Box>
            </Box>
          </Container>
        </Box>
      </Dialog>
    </div>
  )
}

const EditableTaskRow = ({ taskItem, setTasks, cellSx }) => {
  const [isEditing, setIsEditing] = useState(taskItem.isEditing || false)
  const [date, setDate] = useState(taskItem.DateCreation)
  const [taskText, setTaskText] = useState(taskItem.Nom)

  // const handleSave = () => {
  //   setTasks((prevTasks) =>
  //     prevTasks.map((t) =>
  //       t.id === taskItem.id ? { ...t, date, task: taskText, isEditing: false } : t,
  //     ),
  //   )
  //   setIsEditing(false)
  // }

  // const handleDelete = () => {
  //   setTasks((prevTasks) => prevTasks.filter((t) => t.id !== taskItem.id))
  // }

  // const displayDate = new Date(date).toLocaleDateString('fr-FR', {
  //   day: '2-digit',
  //   month: '2-digit',
  //   year: 'numeric',
  // })

  return (
    <TableRow
      sx={{
        '&:last-child td, &:last-child th': { border: 0 },
      }}
    >
      <TableCell sx={{ ...cellSx, border: 'none', paddingY: 1 }}>
        {isEditing ? (
          <TextField
            type="date"
            size="small"
            value={date}
            onChange={(e) => setDate(e.target.value)}
            sx={{ ...darkInputStyle, width: '100%', minWidth: '100px' }}
          />
        ) : (
          <Typography sx={{ whiteSpace: 'nowrap' }}>{date}</Typography>
        )}
      </TableCell>
      <TableCell sx={{ ...cellSx, border: 'none', paddingY: 1 }}>
        {isEditing ? (
          <TextField
            size="small"
            fullWidth
            value={taskText}
            onChange={(e) => setTaskText(e.target.value)}
            sx={darkInputStyle}
          />
        ) : (
          <Typography>{taskText}</Typography>
        )}
      </TableCell>
      {/* <TableCell sx={{ ...cellSx, border: 'none', paddingY: 1, textAlign: 'right', width: '50px' }}>
        {isEditing ? (
          <IconButton
            onClick={handleSave}
            size="small"
            sx={{ color: '#34d399' }}
            aria-label="save task"
          >
            <SaveOutlinedIcon fontSize="small" />
          </IconButton>
        ) : (
          <IconButton
            onClick={() => setIsEditing(true)}
            size="small"
            sx={{ color: '#3b82f6' }}
            aria-label="edit task"
          >
            <EditOutlinedIcon fontSize="small" />
          </IconButton>
        )}
        <IconButton
          onClick={handleDelete}
          size="small"
          sx={{ color: '#f87171' }}
          aria-label="delete task"
        >
          <DeleteOutlineIcon fontSize="small" />
        </IconButton>
      </TableCell> */}
    </TableRow>
  )
}

const EditableNoteRow = ({ noteItem, setNotes, cellSx }) => {
  const [isEditing, setIsEditing] = useState(noteItem.isEditing || false)
  const [date, setDate] = useState(noteItem.DateCreation)
  const [noteText, setNoteText] = useState(noteItem.Details)

  // const handleSave = () => {
  //   setNotes((prevNotes) =>
  //     prevNotes.map((n) =>
  //       n.id === noteItem.id ? { ...n, date, note: noteText, isEditing: false } : n,
  //     ),
  //   )
  //   setIsEditing(false)
  // }

  // const handleDelete = () => {
  //   setNotes((prevNotes) => prevNotes.filter((n) => n.id !== noteItem.id))
  // }

  // const displayDate = new Date(date).toLocaleDateString('fr-FR', {
  //   day: '2-digit',
  //   month: '2-digit',
  //   year: 'numeric',
  // })

  return (
    <TableRow
      sx={{
        '&:last-child td, &:last-child th': { border: 0 },
      }}
    >
      <TableCell
        sx={{ ...cellSx, border: 'none', paddingY: 1, verticalAlign: 'top', width: '100px' }}
      >
        {isEditing ? (
          <TextField
            type="date"
            size="small"
            value={date}
            onChange={(e) => setDate(e.target.value)}
            sx={{ ...darkInputStyle, width: '100%', minWidth: '100px' }}
          />
        ) : (
          <Typography sx={{ whiteSpace: 'nowrap' }}>{date}</Typography>
        )}
      </TableCell>
      <TableCell sx={{ ...cellSx, border: 'none', paddingY: 1 }}>
        {isEditing ? (
          <TextField
            size="small"
            fullWidth
            multiline
            rows={3}
            value={noteText}
            onChange={(e) => setNoteText(e.target.value)}
            sx={darkInputStyle}
          />
        ) : (
          <Typography sx={{ whiteSpace: 'pre-wrap' }}>{noteText}</Typography>
        )}
      </TableCell>
      {/* <TableCell
        sx={{
          ...cellSx,
          border: 'none',
          paddingY: 1,
          textAlign: 'right',
          width: '50px',
          verticalAlign: 'top',
        }}
      >
        {isEditing ? (
          <IconButton
            onClick={handleSave}
            size="small"
            sx={{ color: '#34d399' }}
            aria-label="save note"
          >
            <SaveOutlinedIcon fontSize="small" />
          </IconButton>
        ) : (
          <IconButton
            onClick={() => setIsEditing(true)}
            size="small"
            sx={{ color: '#3b82f6' }}
            aria-label="edit note"
          >
            <EditOutlinedIcon fontSize="small" />
          </IconButton>
        )}
        <IconButton
          onClick={handleDelete}
          size="small"
          sx={{ color: '#f87171' }}
          aria-label="delete note"
        >
          <DeleteOutlineIcon fontSize="small" />
        </IconButton>
      </TableCell> */}
    </TableRow>
  )
}

const TaskNoteTabContent = ({ row }) => {
  const [tasks, setTasks] = useState([])
  const [notes, setNotes] = useState([])
  const [createTache, setCreateTache] = useState(false)
  const [createNote, setCreateNote] = useState(false)

  useEffect(() => {
    getTaskList()
    getNoteList()
  }, [])

  const getTaskList = async () => {
    const { data } = await makeGetRequest(
      `/api/mestodo/task-operations/?OpfiId=${row.id}`,
      {},
      true,
    )
    setTasks(data.results)
  }
  const getNoteList = async () => {
    const { data } = await makeGetRequest(
      `/api/mestodo/note-operations/?OpfiId=${row.id}`,
      {},
      true,
    )
    setNotes(data.results)
  }

  const cellSx = {
    color: 'white',
    fontWeight: 400,
    fontSize: { xs: '0.85rem', sm: '1rem' },
  }

  const updateTodo = async () => {
    getTaskList()
    getNoteList()
  }
  return (
    <>
      {createTache && (
        <CreateTache
          setCreateTache={setCreateTache}
          updateTodo={updateTodo}
          operationFiId={row.id}
        />
      )}
      {createNote && (
        <CreateNote setCreateNote={setCreateNote} updateTodo={updateTodo} op_id={row.id} />
      )}
      <Box
        sx={{
          padding: { xs: 2, sm: 3 },
          backgroundColor: '#1f2937',
          borderRadius: '8px',
          boxShadow: '0 10px 15px rgba(0, 0, 0, 0.2)',
        }}
      >
        <Box sx={{ display: 'flex', gap: 2, marginBottom: 4 }}>
          <Button
            variant="contained"
            startIcon={<AddBoxOutlinedIcon />}
            sx={{
              backgroundColor: '#3b82f6',
              color: 'white',
              textTransform: 'none',
              fontWeight: 600,
              borderRadius: '8px',
              '&:hover': { backgroundColor: '#2563eb' },
              flexGrow: 1,
            }}
            onClick={() => setCreateTache(true)}
          >
            + Tâche
          </Button>
          <Button
            variant="contained"
            startIcon={<NoteAddOutlinedIcon />}
            sx={{
              backgroundColor: '#3b82f6',
              color: 'white',
              textTransform: 'none',
              fontWeight: 600,
              borderRadius: '8px',
              '&:hover': { backgroundColor: '#2563eb' },
              flexGrow: 1,
            }}
            onClick={() => setCreateNote(true)}
          >
            + Note
          </Button>
        </Box>

        {tasks.length > 0 && (
          <>
            <Typography
              variant="h6"
              sx={{
                color: 'white',
                marginBottom: 2,
                borderBottom: '1px solid #374151',
                paddingBottom: 1,
              }}
            >
              Tâches
            </Typography>
            <TableContainer
              component={Paper}
              sx={{ bgcolor: 'transparent', boxShadow: 'none', marginBottom: 4 }}
            >
              <Table sx={{ minWidth: 400 }} aria-label="tasks table">
                <TableHead>
                  <TableRow>
                    <TableCell
                      sx={{
                        ...cellSx,
                        color: '#9ca3af',
                        fontWeight: 500,
                        width: '100px',
                        borderBottom: '1px solid #374151',
                      }}
                    >
                      Date
                    </TableCell>
                    <TableCell
                      sx={{
                        ...cellSx,
                        color: '#9ca3af',
                        fontWeight: 500,
                        borderBottom: '1px solid #374151',
                      }}
                    >
                      Tâches
                    </TableCell>
                    {/* <TableCell sx={{ ...cellSx, width: '50px', borderBottom: 'none' }}></TableCell> */}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {tasks.map((taskItem) => (
                    <EditableTaskRow
                      key={taskItem.id}
                      taskItem={taskItem}
                      setTasks={setTasks}
                      cellSx={cellSx}
                    />
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </>
        )}

        {notes.length > 0 && (
          <>
            <Typography
              variant="h6"
              sx={{
                color: 'white',
                marginBottom: 2,
                borderBottom: '1px solid #374151',
                paddingBottom: 1,
              }}
            >
              Note
            </Typography>
            <TableContainer component={Paper} sx={{ bgcolor: 'transparent', boxShadow: 'none' }}>
              <Table sx={{ minWidth: 400 }} aria-label="notes table">
                <TableHead>
                  <TableRow>
                    <TableCell
                      sx={{
                        ...cellSx,
                        color: '#9ca3af',
                        fontWeight: 500,
                        width: '100px',
                        borderBottom: '1px solid #374151',
                      }}
                    >
                      Date
                    </TableCell>
                    <TableCell
                      sx={{
                        ...cellSx,
                        color: '#9ca3af',
                        fontWeight: 500,
                        borderBottom: '1px solid #374151',
                      }}
                    >
                      Note
                    </TableCell>
                    {/* <TableCell sx={{ ...cellSx, width: '50px', borderBottom: 'none' }}></TableCell> */}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {notes.map((noteItem) => (
                    <EditableNoteRow
                      key={noteItem.id}
                      noteItem={noteItem}
                      setNotes={setNotes}
                      cellSx={cellSx}
                    />
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </>
        )}
      </Box>
    </>
  )
}

const EventTabContent = ({ row }) => {
  const [events, setEvents] = useState([])
  const [showModal, setShowModal] = useState(false)
  const [event, setEvent] = useState({})

  const toggleModal = () => {
    setShowModal(!showModal)
  }
  useEffect(() => {
    getOperationEvent()
  }, [])
  useEffect(() => {
    if (event?.start_date) {
      insertEvent()
    }
  }, [event])

  const getOperationEvent = async () => {
    const { data } = await makeGetRequest(`/api/Finance/get-event-opfsi/${row.id}/`, {}, true)
    setEvents([...data])
  }
  const insertEvent = async () => {
    const payload = {
      EventData: event,
      opid: row.id,
    }
    const response = await makePostRequest('/api/Finance/add-event-opfsi/', payload, {}, true)
    if (response.status === 200) {
      setEvent({})
      getOperationEvent()
    }
  }

  const cellSx = {
    color: 'white',
    borderBottom: '1px solid #374151', // Dark border
    padding: 1.5,
    fontWeight: 400,
    fontSize: { xs: '0.85rem', sm: '1rem' },
    verticalAlign: 'middle',
  }

  return (
    <>
      {showModal && (
        <CreateEvent isOpen={showModal} toggleModal={toggleModal} setEvent={setEvent} />
      )}
      <Box
        sx={{
          padding: { xs: 2, sm: 3 },
          backgroundColor: '#1f2937',
          borderRadius: '8px',
          boxShadow: '0 10px 15px rgba(0, 0, 0, 0.2)',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            marginBottom: 3,
          }}
        >
          <Button
            variant="contained"
            startIcon={<EventOutlinedIcon />}
            sx={{
              backgroundColor: '#3b82f6',
              color: 'white',
              textTransform: 'none',
              fontWeight: 600,
              borderRadius: '8px',
              '&:hover': {
                backgroundColor: '#2563eb',
              },
            }}
            onClick={() => {
              setShowModal(true)
              setEvent({})
            }}
          >
            + événements
          </Button>
        </Box>
        {events.length > 0 && (
          <TableContainer>
            <Table sx={{ minWidth: 400 }} aria-label="events table">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ ...cellSx, color: '#9ca3af', fontWeight: 500, width: '150px' }}>
                    Date
                  </TableCell>
                  <TableCell sx={{ ...cellSx, color: '#9ca3af', fontWeight: 500 }}>
                    Evenement
                  </TableCell>
                  {/* <TableCell
                  sx={{
                    ...cellSx,
                    color: '#9ca3af',
                    fontWeight: 500,
                    width: '50px',
                    textAlign: 'right',
                  }}
                >
                  Actions
                </TableCell> */}
                </TableRow>
              </TableHead>
              <TableBody>
                {events.map((eventItem) => (
                  <EditableEventRow
                    key={eventItem.id}
                    eventItem={eventItem}
                    setEvents={setEvents}
                    cellSx={cellSx}
                  />
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Box>
    </>
  )
}

const BudgetRow = ({ label, control, isLast = false }) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      paddingY: 2,
      borderBottom: isLast ? 'none' : '1px solid rgba(55, 65, 81, 0.7)',
    }}
  >
    <Typography
      sx={{
        color: '#9ca3af',
        fontWeight: 300,
        fontSize: { xs: '0.875rem', sm: '1rem' },
      }}
    >
      {label}
    </Typography>
    <Box>{control}</Box>
  </Box>
)
const periods = [
  { id: 'Daily', name: 'Daily' },
  { id: 'Weekly', name: 'Weekly' },
  { id: 'Monthly', name: 'Monthly' },
  { id: 'Yearly', name: 'Yearly' },
]

const BudgetTabContent = ({ row, setBudgetVal }) => {
  const [isBudgetActive, setIsBudgetActive] = useState(false)
  const [category, setCategory] = useState(
    row.SousCategorie.length > 0 ? row.SousCategorie[0].id : '',
  )
  const [period, setPeriod] = useState('')

  const [endDate, setEndDate] = useState('')
  const [amount, setAmount] = useState('350')
  const [categories, setCategories] = useState([])

  useEffect(() => {
    setIsBudgetActive(row.is_budgeted)
    setAmount(row.Montant)
    if (row.budget_end_date) {
      setEndDate(convertToMuiDate(row.budget_end_date))
    }
    if (row.budget_frequency) {
      setPeriod(row.budget_frequency)
    }

    fetchCategory()
  }, [])
  const fetchCategory = async () => {
    const { data } = await makeGetRequest('/api/Finance/Categoriesfi/', {}, true)
    setCategories([...data])
  }
  const updateBudget = async () => {
    const response = await makePostRequest(
      '/api/Finance/update-opfsi/',
      {
        is_budgeted: isBudgetActive,
        SousCategorie: category,
        period: period,
        endDate: endDate,
        amount: amount,
        opid: row.id,
      },
      {},
      true,
    )
    if (response.status === 200) {
      toast.success('The transactions have been successfully created in the current budget.')
    } else {
      toast.error('Something missing.')
    }
  }
  return (
    <Box
      sx={{
        padding: { xs: 2, sm: 3 },
        backgroundColor: '#1f2937',
        borderRadius: '8px',
        boxShadow: '0 10px 15px rgba(0, 0, 0, 0.2)',
      }}
    >
      <BudgetRow
        label="Budget"
        control={
          <FormControlLabel
            control={
              <Switch
                checked={isBudgetActive}
                onChange={(e) => setIsBudgetActive(e.target.checked)}
                sx={{
                  '& .MuiSwitch-thumb': {
                    backgroundColor: isBudgetActive ? '#34d399' : '#9ca3af',
                  },
                  '& .MuiSwitch-track': {
                    backgroundColor: isBudgetActive
                      ? 'rgba(52, 211, 153, 0.5)'
                      : 'rgba(156, 163, 175, 0.5)',
                  },
                }}
              />
            }
            label={
              <Typography
                sx={{
                  color: isBudgetActive ? '#34d399' : '#9ca3af',
                  fontWeight: 500,
                  fontSize: '1rem',
                }}
              >
                {isBudgetActive ? 'YES' : 'NO'}
              </Typography>
            }
            labelPlacement="end"
            sx={{ margin: 0, '.MuiTypography-root': { color: 'white' } }}
          />
        }
      />

      <React.Fragment>
        <BudgetRow
          label="Catégorie"
          control={
            <FormControl size="small" sx={{ minWidth: 120, ...darkInputStyle }}>
              <Select value={category} onChange={(e) => setCategory(e.target.value)}>
                {categories.map((c) => (
                  <MenuItem key={c} value={c.id}>
                    {c.SousCategorie}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          }
        />

        <BudgetRow
          label="Period"
          control={
            <FormControl size="small" sx={{ minWidth: 120, ...darkInputStyle }}>
              <Select value={period} onChange={(e) => setPeriod(e.target.value)}>
                {periods.map((p) => (
                  <MenuItem key={p} value={p.id}>
                    {p.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          }
        />

        <BudgetRow
          label="Date de fin"
          control={
            <TextField
              type="date"
              size="small"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              sx={{ minWidth: 140, ...darkInputStyle }}
            />
          }
        />

        <BudgetRow
          label="Montant"
          control={
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <TextField
                size="small"
                type="number"
                value={amount}
                onChange={(e) => {
                  setAmount(e.target.value)
                  setBudgetVal(e.target.value)
                }}
                inputProps={{ min: '0', step: '0.01', style: { color: 'white' } }}
                sx={{ minWidth: 100, ...darkInputStyle }}
              />
              <Typography sx={{ color: 'white', marginLeft: 1 }}>€</Typography>
            </Box>
          }
          isLast
        />
      </React.Fragment>
      <Box sx={{ display: 'flex' }}>
        <Button
          sx={{ ml: 'auto' }}
          variant="outlined"
          onClick={updateBudget}
          disabled={!category || !period}
        >
          Update
        </Button>
      </Box>
    </Box>
  )
}

const darkInputStyle = {
  '& .MuiOutlinedInput-root': {
    color: 'white',
    '& fieldset': {
      borderColor: '#4b5563',
    },
    '&:hover fieldset': {
      borderColor: '#6b7280',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#3b82f6',
    },
  },
  '& .MuiInputLabel-root': {
    color: '#9ca3af',
  },
  '& .MuiSelect-icon': {
    color: '#9ca3af',
  },

  '& input[type="date"]': {
    color: 'white',
  },
  '& input[type="date"]::-webkit-calendar-picker-indicator': {
    filter: 'invert(1)',
  },
}

const EditableEventRow = ({ eventItem, setEvents, cellSx }) => {
  const [isEditing, setIsEditing] = useState(eventItem.isEditing || false)
  const [date, setDate] = useState(eventItem.date)
  const [eventText, setEventText] = useState(eventItem.event)

  const handleSave = () => {
    setEvents((prevEvents) =>
      prevEvents.map((e) =>
        e.id === eventItem.id ? { ...e, date, event: eventText, isEditing: false } : e,
      ),
    )
    setIsEditing(false)
  }

  const handleDelete = () => {
    setEvents((prevEvents) => prevEvents.filter((e) => e.id !== eventItem.id))
  }

  // const displayDate = new Date(date).toLocaleDateString('fr-FR', {
  //   day: '2-digit',
  //   month: '2-digit',
  //   year: 'numeric',
  // })

  return (
    <TableRow
      sx={{
        '&:last-child td, &:last-child th': { border: 0 },
      }}
    >
      <TableCell sx={cellSx}>
        {isEditing ? (
          <TextField
            type="date"
            size="small"
            value={date}
            onChange={(e) => setDate(e.target.value)}
            sx={{ ...darkInputStyle, width: '100%', minWidth: '130px' }}
          />
        ) : (
          <Typography>{date}</Typography>
        )}
      </TableCell>
      <TableCell sx={cellSx}>
        {isEditing ? (
          <TextField
            size="small"
            fullWidth
            value={eventText}
            onChange={(e) => setEventText(e.target.value)}
            sx={darkInputStyle}
          />
        ) : (
          <Typography>{eventText}</Typography>
        )}
      </TableCell>
      {/* <TableCell sx={{ ...cellSx, textAlign: 'right' }}>
        {isEditing ? (
          <IconButton onClick={handleSave} size="small" sx={{ color: '#34d399' }} aria-label="save">
            <SaveOutlinedIcon fontSize="small" />
          </IconButton>
        ) : (
          <IconButton
            onClick={() => setIsEditing(true)}
            size="small"
            sx={{ color: '#3b82f6' }}
            aria-label="edit"
          >
            <EditOutlinedIcon fontSize="small" />
          </IconButton>
        )}
        <IconButton
          onClick={handleDelete}
          size="small"
          sx={{ color: '#f87171' }}
          aria-label="delete"
        >
          <DeleteOutlineIcon fontSize="small" />
        </IconButton>
      </TableCell> */}
    </TableRow>
  )
}

const ContactTabContent = ({ row }) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [contactAllocationData, setContactAllocationData] = useState([])

  const handleOpenModal = () => setIsModalOpen(true)
  const handleCloseModal = () => setIsModalOpen(false)

  const cellSx = {
    color: 'white',
    borderBottom: '1px solid #374151',
    padding: 1.5,
    fontWeight: 400,
    fontSize: { xs: '0.85rem', sm: '1rem' },
  }
  useEffect(() => {
    getAllocationContact()
  }, [])
  const getAllocationContact = async () => {
    const response = await makeGetRequest(`/api/Finance/get-op-split/${row.id}/`, {}, true)
    if (response.status === 200) {
      setContactAllocationData(response.data)
    }
  }

  return (
    <Box
      sx={{
        padding: { xs: 2, sm: 3 },
        backgroundColor: '#1f2937',
        borderRadius: '8px',
        boxShadow: '0 10px 15px rgba(0, 0, 0, 0.2)',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: 3,
        }}
      >
        <Typography
          variant="body1"
          sx={{ color: 'white', fontSize: { xs: '1rem', sm: '1.125rem' } }}
        >
          Répartition par contact
        </Typography>
        <Button
          variant="contained"
          startIcon={<PersonAddOutlinedIcon />}
          sx={{
            backgroundColor: '#3b82f6',
            color: 'white',
            textTransform: 'none',
            fontWeight: 600,
            borderRadius: '8px',
            '&:hover': {
              backgroundColor: '#2563eb',
            },
          }}
          onClick={handleOpenModal}
        >
          + Affecter contact
        </Button>
      </Box>

      {contactAllocationData.length > 0 && (
        <TableContainer>
          <Table sx={{ minWidth: 300 }} aria-label="contact allocation table">
            <TableHead>
              <TableRow>
                <TableCell sx={{ ...cellSx, color: '#9ca3af', fontWeight: 500 }}>Contact</TableCell>
                <TableCell align="right" sx={{ ...cellSx, color: '#9ca3af', fontWeight: 500 }}>
                  Montant
                </TableCell>
                <TableCell align="right" sx={{ ...cellSx, color: '#9ca3af', fontWeight: 500 }}>
                  %
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {contactAllocationData.map((row, index) => (
                <TableRow
                  key={index}
                  sx={{
                    backgroundColor: row.isTotal ? 'rgba(55, 65, 81, 0.3)' : 'transparent',
                    '&:last-child td, &:last-child th': { border: 0 },
                  }}
                >
                  <TableCell
                    component="th"
                    scope="row"
                    sx={{
                      ...cellSx,
                      fontWeight: row.isTotal ? 700 : 400,
                      borderBottom: row.isTotal ? 'none' : cellSx.borderBottom,
                    }}
                  >
                    {row.contact}
                  </TableCell>
                  <TableCell
                    align="right"
                    sx={{
                      ...cellSx,
                      fontWeight: row.isTotal ? 700 : 400,
                      borderBottom: row.isTotal ? 'none' : cellSx.borderBottom,
                    }}
                  >
                    {row.montant}
                  </TableCell>
                  <TableCell
                    align="right"
                    sx={{
                      ...cellSx,
                      fontWeight: row.isTotal ? 700 : 400,
                      borderBottom: row.isTotal ? 'none' : cellSx.borderBottom,
                    }}
                  >
                    {row.percent}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      <ContactAssignmentModal open={isModalOpen} handleClose={handleCloseModal} row={row} />
    </Box>
  )
}

const ContactAssignmentModal = ({ open, handleClose, row }) => {
  const [selectedContact, setSelectedContact] = useState('')
  const [percentage, setPercentage] = useState('')
  const [error, setError] = useState('')
  const [availableContacts, setAvailableContacts] = useState([])

  useEffect(() => {
    getContacts()
  }, [])
  const getContacts = async (pagination = '') => {
    let url = `/api/Social/get-all-contacts/`

    if (pagination !== '') {
      url += pagination
    }
    const response = await makeGetRequest(url, {}, true)
    if (response.status === 200) {
      let clist = []
      response.data.forEach((item) => {
        clist.push({ id: item.id, name: item.full_name })
      })

      setAvailableContacts(clist)
    }
  }

  const handleValidation = async () => {
    const response = await makePostRequest(
      '/api/Finance/add-op-split/',
      { id: selectedContact, percentage: percentage, opid: row.id },
      {},
      true,
    )
    if (response.status === 200) {
      handleCloses()
    } else {
      setError(response.data)
    }
  }
  const handleCloses = () => {
    setPercentage('')
    setSelectedContact('')
    setError('')
    handleClose()
  }
  const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '90%', sm: 400 },
    bgcolor: '#1f2937',
    borderRadius: '12px',
    boxShadow: 24,
    p: 4,
    color: 'white',
    border: '1px solid #374151',
  }

  const darkInputStyle = {
    '& .MuiOutlinedInput-root': {
      color: 'white',
      '& fieldset': {
        borderColor: '#4b5563',
      },
      '&:hover fieldset': {
        borderColor: '#6b7280',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#3b82f6',
      },
    },
    '& .MuiInputLabel-root': {
      color: '#9ca3af',
    },
    '& .MuiSelect-icon': {
      color: '#9ca3af',
    },
  }

  return (
    <Modal
      open={open}
      onClose={handleCloses}
      aria-labelledby="contact-assignment-modal-title"
      aria-describedby="contact-assignment-modal-description"
    >
      <Box sx={modalStyle}>
        <Typography
          id="contact-assignment-modal-title"
          variant="h6"
          component="h2"
          sx={{ marginBottom: 3, fontWeight: 600, textAlign: 'center' }}
        >
          Affecter contact à opération
        </Typography>

        <FormControl fullWidth size="small" sx={{ marginBottom: 3, ...darkInputStyle }}>
          <InputLabel id="select-contact-label">Sélectionner un contact</InputLabel>
          <Select
            labelId="select-contact-label"
            value={selectedContact}
            label="Sélectionner un contact"
            onChange={(e) => setSelectedContact(e.target.value)}
          >
            {availableContacts.map((contact) => (
              <MenuItem key={contact.id} value={contact.id}>
                {contact.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 4 }}>
          <Typography
            sx={{
              color: '#9ca3af',
              marginRight: 2,
              whiteSpace: 'nowrap',
              fontSize: { xs: '0.875rem', sm: '1rem' },
            }}
          >
            Répartition de l'opération
          </Typography>
          <TextField
            size="small"
            type="number"
            value={percentage}
            onChange={(e) => setPercentage(e.target.value)}
            inputProps={{ min: '0', max: '100', step: '1' }}
            sx={{ flexGrow: 1, ...darkInputStyle }}
          />
          <Typography sx={{ color: 'white', marginLeft: 1, fontWeight: 500 }}>%</Typography>
        </Box>
        <Box sx={{ color: 'red' }}>{error}</Box>

        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
          <Button
            onClick={handleCloses}
            sx={{
              color: '#9ca3af',
              textTransform: 'none',
              '&:hover': { bgcolor: 'rgba(255, 255, 255, 0.1)' },
            }}
          >
            Annuler
          </Button>
          <Button
            variant="contained"
            onClick={handleValidation}
            disabled={!selectedContact || !percentage || percentage < 0 || percentage > 100}
            sx={{
              backgroundColor: '#3b82f6',
              color: 'white',
              textTransform: 'none',
              fontWeight: 600,
              borderRadius: '8px',
              '&:hover': {
                backgroundColor: '#2563eb',
              },
            }}
          >
            Valider
          </Button>
        </Box>
      </Box>
    </Modal>
  )
}

function BasicTable1({ op_row }) {
  const siteUser = useSelector((store) => store.user)

  let params = useParams()
  const [selected, setSelected] = React.useState([])

  const [rowsPerPage, setRowsPerPage] = React.useState(20)
  const [newRows, setNewRows] = useState([])

  useEffect(() => {
    fetchOperations(op_row.id, 20)
  }, [])
  const fetchOperations = async (id, limit) => {
    const { data, status } = await makeGetRequest(
      `/api/Administrative/operationfi/${id}/?limit=${limit}`,
      {},
      true,
    )
    if (status === 200) {
      let results = data.results
      setNewRows([...results])
    }
  }
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(rowsPerPage + 20)
    fetchOperations(op_row.id, rowsPerPage + 20)
  }
  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name)
    let newSelected = []
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name)
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1))
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1))
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      )
    }

    setSelected(newSelected)
  }
  const deleteBulkOperations = async () => {
    if (selected.length === 0) {
      alert('Sélectionner une operation ')
    } else {
      const response = await makePostRequest(
        urls.deleteDocumentsBulkOperations,
        { selected: selected },
        {},
        true,
      )
      if (response.status === 200) {
        fetchOperations(op_row.id, 20)
        setSelected([])
      }
    }
  }
  return (
    <>
      <Box>
        <Typography variant="h5" pl={3} pt={3} sx={{ color: 'white' }}>
          Related documents
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }} py={5}>
        <Box>
          <Typography variant="h5" pl={3} sx={{ color: 'white' }}>
            Documents ({newRows.length})
          </Typography>
        </Box>
        <Box>
          <CreateDocumentsForm params={op_row} account="OperationFi" setNewRows={setNewRows} />
          <CustomButton onClick={deleteBulkOperations}>Supprimer</CustomButton>
        </Box>
      </Box>
      <Box sx={{ color: 'white', paddingBottom: '60px' }}>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650, marginTop: '23px' }} size="small" aria-label="simple table">
            <TableBody>
              {newRows && newRows.length > 0 ? (
                newRows.map((row, index) => (
                  <TableRow
                    key={row.id}
                    sx={{ height: '80px', '&:last-child td, &:last-child th': { border: 0 } }}
                  >
                    <TableCell
                      component="th"
                      scope="row"
                      sx={{ display: 'flex', alignItems: 'center' }}
                    >
                      <Checkbox
                        onClick={(event) => handleClick(event, row.id)}
                        color="primary"
                        inputProps={{
                          'aria-labelledby': index,
                        }}
                      />

                      <AttachmentIcon sx={{ padding: '0px 13px', fontSize: '45px' }} />
                      <div>
                        <Link sx={{ fontSize: '16px' }} href={row.Lien}>
                          {row.Lien.split('/').pop()}
                        </Link>
                        <br />
                        Charge le: {convertToUserDateFormate(siteUser.user, row.Datedimport)} -
                        Taille de fichier: {row.FileSize} Mio
                      </div>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={3}>No data yet.</TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>

          {newRows.length > 20 ? (
            <Box display={'flex'} justifyContent={'center'}>
              <Button onClick={handleChangeRowsPerPage}>Load More</Button>
            </Box>
          ) : (
            newRows.length > 20 && (
              <Box display={'flex'} justifyContent={'center'}>
                <Button
                  onClick={() => {
                    fetchOperations(op_row.id, 20)
                    setRowsPerPage(20)
                  }}
                >
                  Return to initial Size
                </Button>
              </Box>
            )
          )}
        </TableContainer>
      </Box>
    </>
  )
}
